let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9wm6N")).then(() => parcelRequire('kP1HF'));